var React = require('react');

function Search2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.9239 7.44249C22.033 10.5516 22.033 15.5924 18.9239 18.7015C15.8148 21.8106 10.7739 21.8106 7.66483 18.7015C4.55573 15.5924 4.55573 10.5516 7.66483 7.44249C10.7739 4.3334 15.8148 4.3334 18.9239 7.44249","stroke":"#323232","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.8662 18.7467L26.6662 26.6534","stroke":"#323232","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search2.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Search2;

Search2.default = Search2;
